// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"41e1a4c6","159":"42579742","225":"47090782","346":"0595b317","367":"fb9ee6ad","403":"d5e90ac3","459":"6dc78312","557":"8ddaef74","633":"ca1f1d01","674":"ec85dd32","899":"8e45eb69"}[chunkId] + ".chunk.js";
};